import { defineAccessTokenName } from '@app/utils/defineAccessTokenName';

// JWT пользователя хранится в sessionStorage, а не в localStorage (issue/11055).
// Токен в localStorage переживал закрытие браузера: приложение видело его при
// следующем открытии, пропускало авторизацию по cookie и пускало в CRM даже
// удалённого пользователя — часть экранов работала, часть отвечала
// «Пользователь не найден». sessionStorage умирает вместе с сессией браузера,
// поэтому при следующем открытии приложение обязано пройти AuthenticateByCookie
// и получить отказ, если пользователя больше нет.

export const getAccessToken = (): string | null =>
  sessionStorage.getItem(defineAccessTokenName(window.location.host));

export const setAccessToken = (accessToken: string): void => {
  sessionStorage.setItem(
    defineAccessTokenName(window.location.host),
    accessToken
  );
};

export const removeAccessToken = (): void => {
  sessionStorage.removeItem(defineAccessTokenName(window.location.host));
};

// Разовая уборка токена, оставшегося в localStorage от предыдущей версии
// фронта. Переносить его в sessionStorage нельзя — тогда уже выданный
// бессрочный токен продолжил бы работать и фикс ничего не изменил бы для
// текущих сессий. Пользователь без токена проходит авторизацию по cookie и
// получает свежий, а удалённый — отказ.
export const dropLegacyAccessToken = (): void => {
  localStorage.removeItem(defineAccessTokenName(window.location.host));
};
